import React from "react";
import Modal from "react-modal";
import { FiX } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

Modal.setAppElement("#root");

const DEFAULT_SUCCESS_MESSAGE = "Project has been successfully created.";

function SuccessModal({
  successModal,
  setSuccessModal,
  message,
  // Legacy props still used by Login / older dashboards
  errorMesg,
  cloneMsg,
  setCloneMsg,
  deleteMsg,
  path,
  onClose,
  buttonLabel = "Close",
  hideCloseButton = false,
}) {
  const navigate = useNavigate();

  const displayMessage =
    message ||
    errorMesg ||
    (typeof cloneMsg === "string" && cloneMsg) ||
    deleteMsg ||
    DEFAULT_SUCCESS_MESSAGE;

  const handleClose = () => {
    setSuccessModal(false);
    if (setCloneMsg) setCloneMsg("");
    if (onClose) onClose();
    if (path) navigate(path);
  };

  return (
    <Modal
      isOpen={successModal}
      onRequestClose={handleClose}
      style={{
        overlay: {
          backgroundColor: "rgba(6, 5, 12, 0.72)",
          backdropFilter: "blur(8px)",
          zIndex: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        content: {
          position: "relative",
          inset: "auto",
          top: "auto",
          left: "auto",
          right: "auto",
          bottom: "auto",
          transform: "none",
          width: "min(420px, calc(100vw - 32px))",
          maxHeight: "calc(100vh - 32px)",
          margin: "auto",
          padding: 0,
          border: "1px solid rgba(124, 92, 255, 0.25)",
          borderRadius: "20px",
          background: "#12101c",
          overflow: "hidden",
          outline: "none",
        },
      }}
      className="sx-success-modal"
    >
      <div className="relative p-7 text-center">
        {!hideCloseButton && (
          <button
            type="button"
            onClick={handleClose}
            className="absolute top-4 right-4 p-2 rounded-full text-[#625e83] hover:text-white hover:bg-[rgba(255,255,255,0.06)] transition-colors"
            aria-label="Close"
          >
            <FiX className="w-4 h-4" />
          </button>
        )}

        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[rgba(124,92,255,0.15)] border border-[rgba(124,92,255,0.35)]">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#c4b2ff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h2 className="font-body text-[22px] font-semibold text-white tracking-tight leading-snug px-4">
          {displayMessage}
        </h2>

        <button
          type="button"
          onClick={handleClose}
          className="mt-7 w-full py-3 rounded-xl bg-[#7c5cff] text-white font-body text-[15px] font-semibold hover:bg-[#9d7dff] transition-all hover:-translate-y-px hover:shadow-[0_8px_24px_-8px_rgba(124,92,255,0.6)]"
        >
          {buttonLabel}
        </button>
      </div>
    </Modal>
  );
}

export default SuccessModal;
